module.exports = "precision lowp float;\n\nuniform vec4 color;\n\nvoid main() {\n    gl_FragColor = color;\n}"